import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import NotFound from './views/NotFound.vue';
import Mall from './views/Mall/index.vue';
import Search from './views/Search/index.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    // This is hack for detecting user going Back
    to.meta.fromHistory = savedPosition !== null;

    return new Promise(resolve => {
      window.setTimeout(() => {
        const position = savedPosition ? savedPosition : { x: 0, y: 0 };
        resolve(position);
      }, 300);
    });
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '*',
      redirect: { name: '404' },
    },
    {
      path: '/404',
      name: '404',
      component: NotFound,
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ './views/About.vue'),
    },
    {
      path: '/search',
      name: 'search',
      component: Search,
    },
    {
      path: '/mall/:mallId',
      name: 'mall',
      component: Mall,
      props: true,
    },
    {
      path: '/biz/:bizId',
      name: 'business',
      component: () =>
        import(/* webpackChunkName: "business" */ './views/Business/index.vue'),
      props: true,
    },
  ],
});
